const monthOrder = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

function isMonthGreater(monthA, monthB) {
  return monthOrder.indexOf(monthA) > monthOrder.indexOf(monthB);
}

function moveColumnToEnd(array, columnName) {
  const index = array.indexOf(columnName);
  if (index > -1) {
    array.splice(index, 1); // Remove the element from its current position
    array.push(columnName); // Add it to the end
  }
  return array;
}

function moveColumnToStart(array, columnName) {
  const index = array.indexOf(columnName);
  if (index > -1) {
    array.splice(index, 1); // Remove the element from its current position
    array.unshift(columnName); // Add it to the start
  }
  return array;
}


/**
 * Export utility functions for CSV, Print, PDF, and Excel
 */

// CSV Export Function
// export const exportToCSV = (data, filename, headers = null) => {
//   if (!data || data.length === 0) {
//     alert('No data to export');
//     return;
//   }

//   // If headers not provided, use object keys from first item
//   const csvHeaders = headers || Object.keys(data[0]);

//   // Create CSV content
//   const csvContent = [
//     csvHeaders.join(','),
//     ...data.map(row =>
//       csvHeaders.map(header => {
//         const value = row[header];
//         // Escape commas and quotes in CSV
//         if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
//           return `"${value.replace(/"/g, '""')}"`;
//         }
//         return value || '';
//       }).join(',')
//     )
//   ].join('\n');

//   // Create and download file
//   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//   const link = document.createElement('a');
//   const url = URL.createObjectURL(blob);
//   link.setAttribute('href', url);
//   link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
//   link.style.visibility = 'hidden';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  // Get headers from the first object
  const csvHeaders = Object.keys(data[0]);

  const csvRows = [
    csvHeaders.join(','), // Header row
    ...data.map(row =>
      csvHeaders.map(header => {
        const value = row[header] ?? "";
        // Convert to string and escape commas/quotes
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(',')
    )
  ];

  // Prepend BOM (\uFEFF) to ensure Excel/Google Sheets recognize UTF-8 (for ₱ symbol)
  const csvContent = "\uFEFF" + csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  
  // Required for Safari/iOS: link must be in the DOM
  document.body.appendChild(link);
  link.click();
  
  // Cleanup
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 150);
};



// Print Function
export const export13thMonthSummary = async (printData, title, headers = null) => {
  if (!printData || printData.length === 0) {
    alert('No data to print');
    return;
  }


  const { jsPDF } = await import('jspdf');
  const { autoTable } = await import('jspdf-autotable');

  const doc = new jsPDF({
    orientation: 'landscape',
    format: 'legal'
  });
  //autoTable(doc, { html: '#table', useCss: true, });


  doc.text(title, 10, 10);


  //start function to get columns dynamically, some columns are not present in all rows so we need to loop each one
  let cols = {}
  let bgColors = {}

  //get all keys to define columns
  printData.forEach((item) => {
    //keys
    let objectKeysWithNoBGColor = Object.keys(item).filter(key => !key.includes('_bgcolor'))
    let objectKeysWithBgColor = Object.keys(item).filter(key => key.includes('_bgcolor'))

    //console.log('object keys with bgcolor', objectKeysWithBgColor)

    //assigning columns
    objectKeysWithNoBGColor.forEach(key => {

      //add keys except total, we will add it later
      if (key !== 'Total') {
        //add the column
        cols[`${key}`] = 1
      }
    })

    //assigning bg colors to each added columns
    objectKeysWithBgColor.forEach(key => {

      //transform _bgcolor-OCT1631 to OCT1631
      let bgColorKey = key.replace('_bgcolor-', '')
      bgColors[`${bgColorKey}`] = item[key]
    })

  })
  cols['Total'] = 1 //add total column at the end

  let columns = Object.keys(cols)
  console.log('bgColors', bgColors)

  // Define table columns
  // let columns = Array.from(Object.keys(printData[0]).filter(key => !key.includes('_bgcolor')));
  let sortedColumsByDate = columns.sort((firstElement, secondElement) => {
    if (firstElement === 'Name' || secondElement === 'Name') return -1;
    if (secondElement === 'Total' || secondElement === 'Total') return 1;

    //first element
    let first_el_month = firstElement.substring(0, 3)
    let first_el_year = firstElement.split('-')[1]

    let first_el_date_from = firstElement.substring(3, 5)
    //    let first_el_date_to = firstElement.substring(5, 7)

    //second element
    let second_el_month = secondElement.substring(0, 3)
    let second_el_year = secondElement.split('-')[1]
    let second_el_date_from = secondElement.substring(3, 5)
    //let second_el_date_to = secondElement.substring(5, 7)

    //sort by year
    if (first_el_year > second_el_year) {
      return 1
    }

    if (second_el_year > first_el_year) {
      return -1
    }

    //sort by month
    if (isMonthGreater(first_el_month, second_el_month)) {
      return 1
    }
    if (isMonthGreater(second_el_month, first_el_month)) {
      return -1
    }

    //sort by date from

    if (first_el_date_from > second_el_date_from) {
      return 1;
    }
    if (second_el_date_from > first_el_date_from) {
      return -1
    }


    return 1
  });

  sortedColumsByDate = moveColumnToEnd(sortedColumsByDate, 'Total');
  sortedColumsByDate = moveColumnToStart(sortedColumsByDate, 'Names');

  //sort columns here


  let rows = [
    ...printData.map(row =>
      columns.map(col => {
        const value = row[col];
        const formatted = parseFloat(value);
        if (!isNaN(formatted)) {
          return Number(formatted).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
        }
        return value !== null && value !== undefined ? String(value) : '-';
      })
    ),
    // Add total row at the end
    columns.map(col => {
      if (col === columns[0]) return 'TOTAL';
      const total = printData.reduce((sum, row) => {
        const value = parseFloat(row[col]);
        const formatted = parseFloat(value);

        if (!isNaN(formatted)) {
          return sum + formatted;
        }
        return sum;
      }, 0);
      return total === 0 ? '-' : total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    })
  ]


  //remove dates from columns for display
  let displayColumns = sortedColumsByDate.map(col => {
    if (col === 'Names' || col === 'Total') return col;
    //remove year from column
    return col.substring(0, col.indexOf('-'));
  });


  // Generate table using AutoTable
  doc.autoTable({
    head: [displayColumns],
    body: rows,
    startY: 25,
    useCss: true,
    styles: {
      fontSize: 6,
      cellPadding: 0.5,
      backgroundColor: 'red',
      lineColor: [0, 0, 0], // Black borders
      lineWidth: 0.1
    },
    headerStyles: {
      borderColor: 'black',
      borderWidth: 0.2,
      halign: 'center',
    },
    headStyles: {
      halign: 'center',
    },
    columnStyles: {
      borderColor: 'black',
      borderWidth: 0.1,
      cellWidth: 'auto',
      minCellWidth: 25,
    },
    didParseCell: (data) => {


      let ifColumnHeader = Boolean(columns.includes(data.cell.raw));

      //determine background color key
      let index = data.column.index
      let columnName = columns[index];
      let backgroundColorKey = bgColors[`${columnName}`] || null;
      // console.log('backgroundColorKey', backgroundColorKey, 'for column', columnName, 'at row', data.row.index, 'for value', data.cell.raw);

      //bottom row styling
      if (data.row.index === rows.length - 1) {
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.lineWidth = {
          left: 0.1,
          right: 0.1,
          top: 0.1,
          bottom: 0.8
        };
      }



      //numbers alignment except first column and first row
      if (data.column.index > 0 && !ifColumnHeader) {
        data.cell.styles.halign = 'right';
        data.cell.styles.fillColor = backgroundColorKey;
      }

      if (data.column.index === columns.length - 1) {
        data.cell.styles.fontStyle = 'bold';
      }
      // You can customize cell styles here if needed
    },
    margin: { left: 14, right: 14 },
    pageBreak: 'auto',
    tableWidth: 'auto',
    horizontalPageBreak: true,
    horizontalPageBreakRepeat: 0
  });

  // Save the PDF
  window.open(doc.output('bloburl'), '_blank', 'noopener,noreferrer');

  /*

  console.log('url', url)
  //let url = doc.save('table.pdf').output('bloburl');
  window.open(url, '_blank');

  /*
  printWindow.document.close();
  printWindow.print();
  */
};

export const export13thMonthSummaryCSV = async (printData, title, headers = null) => {
  if (!printData || printData.length === 0) {
    alert('No data to export');
    return;
  }

  let cols = {}

  printData.forEach((item) => {
    let objectKeysWithNoBGColor = Object.keys(item).filter(key => !key.includes('_bgcolor'))
    objectKeysWithNoBGColor.forEach(key => {

      //add keys except total, we will add it later
      if (key !== 'Total') {
        //add the column
        cols[`${key}`] = 1
      }
    })
  })

  cols['Total'] = 1 //add total column at the end

  let columns = Object.keys(cols)
  let sortedColumsByDate = columns.sort((firstElement, secondElement) => {
    if (firstElement === 'Name' || secondElement === 'Name') return -1;
    if (secondElement === 'Total' || secondElement === 'Total') return 1;

    //first element
    let first_el_month = firstElement.substring(0, 3)
    let first_el_year = firstElement.split('-')[1]

    let first_el_date_from = firstElement.substring(3, 5)
    //    let first_el_date_to = firstElement.substring(5, 7)

    //second element
    let second_el_month = secondElement.substring(0, 3)
    let second_el_year = secondElement.split('-')[1]
    let second_el_date_from = secondElement.substring(3, 5)
    //let second_el_date_to = secondElement.substring(5, 7)

    //sort by year
    if (first_el_year > second_el_year) {
      return 1
    }

    if (second_el_year > first_el_year) {
      return -1
    }

    //sort by month
    if (isMonthGreater(first_el_month, second_el_month)) {
      return 1
    }
    if (isMonthGreater(second_el_month, first_el_month)) {
      return -1
    }

    //sort by date from

    if (first_el_date_from > second_el_date_from) {
      return 1;
    }
    if (second_el_date_from > first_el_date_from) {
      return -1
    }


    return 1
  });
  sortedColumsByDate = moveColumnToEnd(sortedColumsByDate, 'Total');
  sortedColumsByDate = moveColumnToStart(sortedColumsByDate, 'Names');

  let rows = [
    ...printData.map(row =>
      columns.map(col => {
        const value = row[col];
        const formatted = parseFloat(value);
        if (!isNaN(formatted)) {
          return Number(formatted).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });;
        }
        return value !== null && value !== undefined ? String(value) : '-';
      })
    ),
    // Add total row at the end
    columns.map(col => {
      if (col === columns[0]) return 'TOTAL';
      const total = printData.reduce((sum, row) => {
        const value = parseFloat(row[col]);
        const formatted = parseFloat(value);

        if (!isNaN(formatted)) {
          return sum + formatted;
        }
        return sum;
      }, 0);
      return total === 0 ? '-' : total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    })
  ]

  let displayColumns = sortedColumsByDate.map(col => {
    if (col === 'Total') return 'TOTAL';
    if (col === 'Names') return 'Names';
    return col.split('-')[0];
  });

  // Create CSV content
  const csvContent = [
    displayColumns.join(','),
    ...rows.map(row =>
      row.map(value => {
        // Escape commas and quotes in CSV
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value || '';
      }).join(',')
    )
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url)
}

export const exportToPrint = (data, title, headers = null) => {
  if (!data || data.length === 0) {
    alert('No data to print');
    return;
  }

  const csvHeaders = headers || Object.keys(data[0]);

  // Create HTML content for printing
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 20px;
        }
        h1 {
          color: #12C1DC;
          border-bottom: 2px solid #12C1DC;
          padding-bottom: 10px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f8f9fa;
          font-weight: bold;
          color: #374151;
        }
        tr:nth-child(even) {
          background-color: #f9fafb;
        }
        .print-date {
          color: #6b7280;
          font-size: 12px;
          margin-bottom: 20px;
        }
      </style>
    </head>
    <body>
      <div class="print-date">Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}</div>
      <h1>${title}</h1>
      <table>
        <thead>
          <tr>
            ${csvHeaders.map(header => `<th>${header}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${data.map(row => `
            <tr>
              ${csvHeaders.map(header => `<td>${row[header] || ''}</td>`).join('')}
            </tr>
          `).join('')}
        </tbody>
      </table>
    </body>
    </html>
  `;

  // Open print window
  const printWindow = window.open('', '_blank');
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  printWindow.print();
};

// PDF Export Function using jsPDF + jspdf-autotable
export const exportToPDF = async (data, filename, title, headers = null) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  try {
    // Dynamic imports to avoid issues if libraries aren't available
    const { jsPDF } = await import('jspdf');
    const autoTableModule = await import('jspdf-autotable');

    // Create PDF document
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });


    // Prepare table data
    const tableHeaders = headers || Object.keys(data[0]);
    const tableData = data.map(row =>
      tableHeaders.map(header => {
        const value = row[header];
        return value !== null && value !== undefined ? String(value) : '';
      })
    );

    // Split table into chunks that fit on page width
    const splitTableIntoChunks = (headers, data) => {
      const pageWidth = doc.internal.pageSize.width - 20; // Account for margins
      const minColumnWidth = 18; // Minimum readable width
      const maxColumnsPerPage = Math.floor(pageWidth / minColumnWidth);

      console.log(`Page width: ${pageWidth}mm, Min column width: ${minColumnWidth}mm, Max columns per page: ${maxColumnsPerPage}`);
      console.log(`Total columns: ${headers.length}`);

      // If we have more columns than can fit on one page, split into chunks
      if (headers.length > maxColumnsPerPage) {
        const chunks = [];
        for (let i = 0; i < headers.length; i += maxColumnsPerPage) {
          const endIndex = Math.min(i + maxColumnsPerPage, headers.length);
          const chunkHeaders = headers.slice(i, endIndex);
          const chunkData = data.map(row =>
            chunkHeaders.map((_, index) => row[i + index])
          );
          chunks.push({
            headers: chunkHeaders,
            data: chunkData,
            startIndex: i,
            endIndex: endIndex - 1
          });
          console.log(`Chunk ${chunks.length}: columns ${i + 1}-${endIndex} (${chunkHeaders.length} columns)`);
        }
        return chunks;
      }

      // If all columns fit on one page, return as single chunk
      console.log('All columns fit on one page');
      return [{
        headers: headers,
        data: data,
        startIndex: 0,
        endIndex: headers.length - 1
      }];
    };

    const tableChunks = splitTableIntoChunks(tableHeaders, tableData);

    // Generate tables for each chunk
    tableChunks.forEach((chunk, chunkIndex) => {
      // Add title and timestamp for each chunk
      if (chunkIndex === 0) {
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text(title, 10, 20);

        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.text(`Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`, 10, 28);
      } else {
        // Add new page for additional chunks
        doc.addPage();
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text(`${title} (Part ${chunkIndex + 1})`, 10, 20);

        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.text(`Columns ${chunk.startIndex + 1}-${chunk.endIndex + 1}`, 10, 28);
      }

      // Calculate optimal column widths for this chunk
      const pageWidth = doc.internal.pageSize.width - 20;
      const columnWidth = Math.max(18, pageWidth / chunk.headers.length);

      console.log(`Chunk ${chunkIndex + 1}: ${chunk.headers.length} columns, column width: ${columnWidth}mm`);

      const autoTable = autoTableModule.default || autoTableModule.autoTable;
      const hasDocumentAutoTable = typeof doc.autoTable === 'function';
      if (typeof autoTable !== 'function' && !hasDocumentAutoTable) {
        throw new Error('PDF table exporter is not available.');
      }

      const autoTableOptions = {
        head: [chunk.headers],
        body: chunk.data,
        startY: chunkIndex === 0 ? 35 : 35,
        styles: {
          fontSize: 7,
          cellPadding: 2,
          lineWidth: 0.1,
          lineColor: [200, 200, 200],
          overflow: 'linebreak',
          halign: 'left',
          valign: 'top',
          textColor: [0, 0, 0]
        },
        headStyles: {
          fillColor: [18, 193, 220], // Your theme color #12C1DC
          textColor: 255,
          fontSize: 7,
          fontStyle: 'bold',
          halign: 'center',
          valign: 'middle',
          overflow: 'linebreak'
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        },
        margin: { top: chunkIndex === 0 ? 35 : 35, left: 10, right: 10 },
        theme: 'grid',
        columnStyles: Object.fromEntries(
          chunk.headers.map((_, index) => [
            index,
            {
              cellWidth: columnWidth,
              overflow: 'linebreak',
              halign: 'left',
              valign: 'top'
            }
          ])
        ),
        didParseCell: (data) => {
          // Handle specific column types
          if (data.column.index === 0 || data.column.index === 1) {
            // ID and Name columns
            data.cell.styles.halign = 'center';
            data.cell.styles.overflow = 'linebreak';
          }
          // Handle long text
          if (data.cell.raw && typeof data.cell.raw === 'string') {
            const textLength = data.cell.raw.length;
            data.cell.styles.overflow = 'linebreak';
            if (textLength > 20) {
              data.cell.styles.fontSize = 6;
            }
            if (textLength > 40) {
              data.cell.styles.fontSize = 5;
            }
          }
          // Handle numeric columns
          if (typeof data.cell.raw === 'number' || /^\d+\.?\d*$/.test(String(data.cell.raw))) {
            data.cell.styles.halign = 'right';
          }
          data.cell.styles.overflow = 'linebreak';
        },
        pageBreak: 'auto',
        showHead: 'everyPage',
        showFoot: 'never'
      };

      if (typeof autoTable === 'function') {
        autoTable(doc, autoTableOptions);
      } else {
        doc.autoTable(autoTableOptions);
      }
    });

    // Add page numbers if multiple pages
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(`Page ${i} of ${pageCount}`, pageSize.width - 30, pageHeight - 10);
    }

    // Save the PDF
    doc.save(`${filename}_${new Date().toISOString().split('T')[0]}.pdf`);

    console.log('PDF exported successfully');

  } catch (error) {
    console.error('PDF export error:', error);
    alert('PDF export failed. Please ensure jsPDF and jspdf-autotable are properly installed.');
  }
};

/**
 * Format data for export based on component type
 */
export const formatDataForExport = (data, type) => {
  if (type === 'groups') {
    return data.map(group => ({
      'ID': group.id,
      'Group Name': group.name,
      'Rebate': Number(group.rebate) || 0,
      'Store Count': group.storeCount,
      'Status': group.active ? 'Active' : 'Inactive',
      'Description': group.description || '',
      'Created Date': new Date(group.created_at).toLocaleDateString(),
      'Updated Date': new Date(group.updated_at).toLocaleDateString()
    }));
  } else if (type === 'stores') {
    return data.map(store => ({
      'ID': store.id,
      'Store Name': store.name,
      'Group': store.group,
      'Location': store.location,
      'Status': store.active ? 'Active' : 'Inactive',
      'Created Date': new Date(store.created_at).toLocaleDateString(),
      'Updated Date': new Date(store.updated_at).toLocaleDateString()
    }));
  }

  return data;
};

// Excel Export Function using exceljs and file-saver
export const exportToExcel = async (data, filename, title, headers = null) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  try {
    // Dynamic imports to avoid issues if libraries aren't available
    const ExcelJS = await import('exceljs');
    const FileSaver = await import('file-saver');

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    // Prepare table data
    const tableHeaders = headers || Object.keys(data[0]);
    const tableData = data.map(row =>
      tableHeaders.map(header => {
        const value = row[header];
        return value !== null && value !== undefined ? String(value) : '';
      })
    );

    // Add title
    worksheet.getCell('A1').value = title;
    worksheet.getCell('A1').font = {
      size: 16,
      bold: true,
      color: { argb: 'FF12C1DC' }
    };
    worksheet.getCell('A1').alignment = { horizontal: 'center' };
    worksheet.mergeCells('A1:' + String.fromCharCode(65 + tableHeaders.length - 1) + '1');

    // Add timestamp
    worksheet.getCell('A2').value = `Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
    worksheet.getCell('A2').font = { size: 10, italic: true };
    worksheet.getCell('A2').alignment = { horizontal: 'center' };
    worksheet.mergeCells('A2:' + String.fromCharCode(65 + tableHeaders.length - 1) + '2');

    // Add headers
    const headerRow = worksheet.getRow(4);
    tableHeaders.forEach((header, index) => {
      const cell = headerRow.getCell(index + 1);
      cell.value = header;
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFFFF' }
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF12C1DC' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    // Add data rows
    tableData.forEach((row, rowIndex) => {
      const dataRow = worksheet.getRow(rowIndex + 5);
      row.forEach((cellValue, colIndex) => {
        const cell = dataRow.getCell(colIndex + 1);
        cell.value = cellValue;

        // Apply different styling based on column type
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        // Center align for specific columns
        if (colIndex === 0 || colIndex === 1) {
          cell.alignment = { horizontal: 'center' };
        } else {
          cell.alignment = { horizontal: 'left' };
        }

        // Style numeric columns
        if (!isNaN(cellValue) && cellValue !== '') {
          cell.alignment = { horizontal: 'right' };
        }
      });
    });

    // Auto-fit columns
    worksheet.columns.forEach((column, index) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 50); // Min 10, Max 50 characters
    });

    // Generate and save file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    FileSaver.saveAs(blob, `${filename}_${new Date().toISOString().split('T')[0]}.xlsx`);

    console.log('Excel exported successfully');
    return true;

  } catch (error) {
    console.error('Excel export error:', error);
    alert('Excel export failed. Please ensure exceljs and file-saver are properly installed.');
    return false;
  }
};



export const formatAmount = (num) => {
  if (typeof num !== 'number') return '';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const getDecimalDigits = (num) => {
    return (Math.round((Math.abs(num) % 1) * 100)).toString().padStart(2, '0');
};
